// ======================================================================
// File Name       : content
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const CONTENT_RECEIVE_LIST = 'CONTENT_RECEIVE_LIST';
export const CONTENT_INIT_EDITING = 'CONTENT_INIT_EDITING';
export const CONTENT_RECEIVE_EDITING = 'CONTENT_RECEIVE_EDITING';
export const CONTENT_DRILL_REGISTER_ADD_QUESTION = 'CONTENT_DRILL_REGISTER_ADD_QUESTION';
export const CONTENT_DRILL_REGISTER_DELETE_QUESTION = 'CONTENT_DRILL_REGISTER_DELETE_QUESTION';
export const CONTENT_DRILL_EDIT_ADD_CONTENT = 'CONTENT_DRILL_EDIT_ADD_CONTENT';
export const CONTENT_DRILL_EDIT_DELETE_CONTENT = 'CONTENT_DRILL_EDIT_DELETE_CONTENT';
export const CONTENT_DRILL_EDIT_GET_SKIN_SET = 'CONTENT_DRILL_EDIT_GET_SKIN_SET';

export const CONTENT_DRILL_REGISTER_ADD_FILE = 'CONTENT_DRILL_REGISTER_ADD_FILE';
export const CONTENT_DRILL_REGISTER_GET_SKIN_SET = 'CONTENT_DRILL_REGISTER_GET_SKIN_SET';
export const CONTENT_DRILL_REGISTER_DATA = 'CONTENT_DRILL_REGISTER_DATA';
export const CONTENT_DRILL_REGISTER_RESET_DATA = 'CONTENT_DRILL_REGISTER_RESET_DATA';
export const CONTENT_DRILL_REGISTER_UPDATE_QUESTION_DIALOG_SEARCH_INFO = 'CONTENT_DRILL_REGISTER_UPDATE_QUESTION_DIALOG_SEARCH_INFO';
export const CONTENT_DRILL_REGISTER_RESET_QUESTION_DIALOG_SEARCH_INFO = 'CONTENT_DRILL_REGISTER_RESET_QUESTION_DIALOG_SEARCH_INFO';
export const CONTENT_DRILL_REGISTER_RESET_QUESTION_DIALOG = 'CONTENT_DRILL_REGISTER_RESET_QUESTION_DIALOG';
export const IMPORT_DRILL_LIST = 'IMPORT_DRILL_LIST';
export const RECEIVED_IMPORTED_FILE_LIST = 'RECEIVED_IMPORTED_FILE_LIST';
export const IMPORT_VIDEO_LIST = 'IMPORT_VIDEO_LIST';
export const RECEIVED_VIDEO_FILE_LIST = 'RECEIVED_VIDEO_FILE_LIST';

export const CONTENT_DRILL_EDIT_ADD_FILE = 'CONTENT_DRILL_EDIT_ADD_FILE';
export const CONTENT_DRILL_EDIT_RESET_DATA = 'CONTENT_DRILL_EDIT_RESET_DATA';

export const CREATE_VALUE_ATTRIBUTE_ITEM_DRILL = 'CREATE_VALUE_ATTRIBUTE_ITEM_DRILL';
export const REMOVE_QUESTION_LIST_DRILL = 'REMOVE_QUESTION_LIST_DRILL';
export const REMOVE_ALL_QUESTION_FROM_LIST = 'REMOVE_ALL_QUESTION_FROM_LIST';
export const REMOVE_GROUP = 'REMOVE_GROUP';
export const ADD_GROUP = 'ADD_GROUP';

// Content notification
export const CONTENT_NOTIFICATION_SEARCH = 'CONTENT_NOTIFICATION_SEARCH';
export const CONTENT_NOTIFICATION_DOWNLOAD = 'CONTENT_NOTIFICATION_DOWNLOAD';
export const CONTENT_NOTIFICATION_REGISTER_EDIT_INIT = 'CONTENT_NOTIFICATION_REGISTER_EDIT_INIT';
export const CONTENT_NOTIFICATION_REGISTER = 'CONTENT_NOTIFICATION_REGISTER';
export const CONTENT_NOTIFICATION_DELETE = 'CONTENT_NOTIFICATION_DELETE';
export const CONTENT_NOTIFICATION_UPDATE = 'CONTENT_NOTIFICATION_UPDATE';
export const CONTENT_NOTIFICATION_REGISTER_RESET = 'CONTENT_NOTIFICATION_REGISTER_RESET';

// Content link
export const CONTENT_LINK_LIST = 'CONTENT_LINK_LIST';
export const CONTENT_LINK_EDIT = 'CONTENT_LINK_EDIT';

// Content Document
export const CONTENT_DOCUMENT_LIST = 'CONTENT_DOCUMENT_LIST';
export const CONTENT_DOCUMENT_SEARCH = 'CONTENT_DOCUMENT_SEARCH';
export const CONTENT_DOCUMENT_DETAIL = 'CONTENT_DOCUMENT_DETAIL';
export const CONTENT_INITIAL_DOCUMENT_DETAIL = 'CONTENT_DOCUMENT_DETAIL';
export const CONTENT_DOCUMENT_EDIT = 'CONTENT_DOCUMENT_EDIT';
export const CONTENT_DOCUMENT_REGISTER = 'CONTENT_DOCUMENT_REGISTER';

// Content Video
export const UPDATE_VIDEO_PROGRESS = 'UPDATE_VIDEO_PROGRESS';
export const CANCEL_UPLOAD = 'CANCEL_UPLOAD';

// Content Multi Language
export const MULTI_LANGUAGE_LIST = 'MULTI_LANGUAGE_LIST';
export const MULTI_LANGUAGE_EDIT = 'MULTI_LANGUAGE_EDIT';
export const MULTI_LANGUAGE_RESET_INFO = 'MULTI_LANGUAGE_RESET_INFO';
export const MULTI_LANGUAGE_RESET_STATUS = 'MULTI_LANGUAGE_RESET_STATUS';
export const MULTI_LANGUAGE_RECEIVE_TRANSLATE_RESPONSE = 'MULTI_LANGUAGE_RECEIVE_TRANSLATE_RESPONSE';
export const MULTI_LANGUAGE_EDIT_LANGUAGE_INFO = 'MULTI_LANGUAGE_EDIT_LANGUAGE_INFO';
export const MULTI_LANGUAGE_DELETE_LANGUAGE_INFO = 'MULTI_LANGUAGE_DELETE_LANGUAGE_INFO';
export const MULTI_LANGUAGE_RECEIVE_CONFIRM_INFO = 'MULTI_LANGUAGE_RECEIVE_CONFIRM_INFO';
export const MULTI_LANGUAGE_REFRESH_LANGUAGE_INFO = 'MULTI_LANGUAGE_REFRESH_LANGUAGE_INFO';
export const MULTI_LANGUAGE_SAVE_LANGUAGE_CODE = 'MULTI_LANGUAGE_SAVE_LANGUAGE_CODE';
export const GET_MULTI_LANGUAGE_PROCESS_RESULT_LIST = 'GET_MULTI_LANGUAGE_PROCESS_RESULT_LIST';
export const GET_MULTI_LANGUAGE_PROCESS_DETAIL = 'GET_MULTI_LANGUAGE_PROCESS_DETAIL';

// STEP9.0.0 START
export const CONTENT_DRILL_QUESTION_FOR_SORT = 'CONTENT_DRILL_QUESTION_FOR_SORT';
export const CONTENT_UPDATE_DISPLAY_ORDER_STRUCTURE_LIST = 'CONTENT_UPDATE_DISPLAY_ORDER_STRUCTURE_LIST';
export const CONTENT_SAVE_DISPLAY_ORDER_DRILL_QUESTION = 'CONTENT_SAVE_DISPLAY_ORDER_DRILL_QUESTION';
// STEP9.0.0 END